import $ from 'jquery';

export default {

	init() {

		var container = document.querySelector('.swiAfterOrderNotes');

		if( container ) {

			var change = container.querySelector('.swiAfterOrderNotes__switch input');
			var fieldsContainer = container.querySelector('.swiAfterOrderNotes__fields');
			var fields = fieldsContainer.querySelectorAll('.form-row');

			var objectOfHeight = fieldsContainer.querySelector('.fields__height');
			var objectOfHeightStyle = getComputedStyle( objectOfHeight );

			var height = 0;
			var marginBottom = 0;

			function invoiceSetHeight() {

				height = objectOfHeight.offsetHeight;
				marginBottom = parseFloat( objectOfHeightStyle.marginBottom.replace('px','') ) ;

				fieldsContainer.style.height = (height + marginBottom) + 'px';

			}

			function invoiceShow() {

				fieldsContainer.style.display = 'block';

				fields.forEach( function(field,index) {

					if( field.getAttribute('id') != 'invoice_address_2_field' ) {
						field.classList.add('validate-required');
					}

				});

			}

			function invoiceHide() {

				fieldsContainer.style.height = '0px';

				setTimeout(
					function() {

						fieldsContainer.style.display = 'none';

						fields.forEach( function(field,index) {

							field.classList.remove('validate-required');

						});

					},
					200
				);

			}

			invoiceHide();

			change.addEventListener('click', function( e ) {

				e.stopPropagation();

				if( change.checked == false ) {

					invoiceHide();

				} else {

					invoiceShow();
					invoiceSetHeight();

				}

			});

			window.addEventListener('resize', function() {

				if( change.checked == true  ) {

					invoiceSetHeight();

				}

			});



		}

	},
	finalize() {

	}

}